import { fade, makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({

    main: {
        maxWidth: '100%',
        padding: '1rem',
        textAlign: 'center',
      
    },
    slider:{
        width:'100%'
    }
}));